import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DwComponent, DwComponentType, DwExpressionService, DwFormContextMode, DwMdFormContextInfo, DwMetaDataFormApi, DwMetaDataFormStateService, 
         DwMetaDataService, DwMetaDataServiceToken, DwSectionBaseComponent, DwUiConfigRegistryService, DwUIMetaDataConfig, DwUIMetaDataConfigToken, 
         DwLookupSearchType, DwOrmDataService, DwOrmDataServiceToken, DwQueryHelper, DwQueryFilter, DwOperator, DwFilterType } 
         from '@devwareapps/devware-cap';
import { debounceTime } from 'rxjs/operators';
import { AppMetaDataLookups, AppMetaDataService } from '../../../../meta-data/app-meta-data.service';
import { Permits2PermitEntity,  Permits2PermitStatusMetaData, PermitsV2MetaDataItemNames, PermitStatusV2, InspectionStatusV2,
         PermitsV2MetaDataService } 
         from '../../meta-data/permitsv2-meta-data.service';
import { Observable, of } from 'rxjs';
import * as moment_ from 'moment';
const moment = moment_;

@DwComponent({
  name: 'PermitsV2 UI Util',
  key: 'permitsV2UiUtil',
  componentType: DwComponentType.formSection,
  isGlobal: false,
  parentItemName: PermitsV2MetaDataItemNames.Permits2Permit,
})
@Component({
  selector: 'permits-v2-ui-util',
  template: ` 
  `
})
export class PermitsV2UiUtilComponent extends DwSectionBaseComponent implements OnDestroy {
  lastJobId: any;
  lastJobNumberId: any;
  formApi: DwMetaDataFormApi;
  jobSiteFC: FormControl;
  wjidFC: FormControl;
  lastModified?: string;

  constructor(
    dwExpressionService: DwExpressionService,
    protected dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
    private dwFormStateService: DwMetaDataFormStateService
  ) {
    super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
    this.formApi = this.dwFormStateService.state.formApi;
  }
  ngOnInit(): void {
  }


  isNewer(modified: string) : boolean {
    if (this.lastModified == undefined || modified == undefined || this.lastModified == modified)
        return false;
    return moment(modified).isAfter(this.lastModified);
  }
  getPermitWithInspections(permitId): Observable<Permits2PermitEntity> {
    const md = new PermitsV2MetaDataService();
    const qh = new DwQueryHelper();
    const query = md.Permits2Permit.CreateQuery()
      .AddFilterAnd(qh.filters.Equal(md.Permits2Permit.PermitId, permitId))
      .AddPrefetchPath(md.Permits2Permit.Relations.Permits2RoInspections);
    query.FieldSettings.LoadAllLookupDisplayFields = true;
    return this.dataService.executeQuerySingle(query);
  }

  setupComponentComplete() {
    this.jobSiteFC = this.getOrCreateFormControl("JobSiteId");
    this.wjidFC = this.getOrCreateFormControl("JobId");
    this.runAfterFormDataLoaded(() => this.setupSubscriptions());
  }

  private setupSubscriptions() {
    const requestEntity = this.formApi.getFormData<Permits2PermitEntity>();
    this.subscriptions.push(this.formApi.getFormDataChanges<Permits2PermitEntity>(400).subscribe(entity => {
      this.handleUpdate(entity);
    }));
  }
  ngOnDestroy(): void {
    for(const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  handleUpdate(requestEntity: Permits2PermitEntity) { 
    this.setWJID(requestEntity); 
    this.setFirstJobSite(requestEntity); 
    this.updateInspectionsIfCanceled(requestEntity);
  }

  updateInspectionsIfCanceled(p: Permits2PermitEntity){
    if (this.isNewer(p.ModifiedByDateTime) && p.PermitStatusId == PermitStatusV2.Canceled)
    this.getPermitWithInspections(p.PermitId).subscribe(updates => {
        const update = {
          Permits2roInspections: updates.Permits2roInspections
        };
        this.formApi.patchFormData(update);
    });
    this.lastModified = p.ModifiedByDateTime;
  }
  setWJID(entity: Permits2PermitEntity) {
    if (!entity.JobNumberId && entity?.JobId) {
      this.wjidFC.setValue(null);
      this.lastJobNumberId = null;
      return;
    } else if (this.lastJobNumberId == entity.JobNumberId)
      return;

    this.lastJobNumberId = entity.JobNumberId;
    if (!entity.JobNumberId) return;

    this.subscriptions.push(
      // This is cache
      this.dwMetaDataService.searchLookup(AppMetaDataLookups.WJIDByJobNumber, 
                        { SearchType: DwLookupSearchType.contains, 
                          PagingInfo: { PageSize: 100, PageNo: 0 }, 
                          SearchString: entity.JobId?.toString() }, 
                        [{ ParamName: 'JobNumberId', ParamValue: entity.JobNumberId.toString() }])
      //this.dwMetaDataService.getLookup(AppMetaDataLookups.WJIDByJobNumber, [{ ParamName: 'JobNumberId', ParamValue: entity.JobNumberId.toString() }])
        .subscribe(lookupItems => {
          if (!entity.JobId && lookupItems.length == 1){
            const newJob = lookupItems[0].Id;
            this.wjidFC.setValue(newJob);
          }
          else if (entity.JobId) {
            const existingLookup = lookupItems.find(li => li.Id == entity.JobId.toString());
            if (!existingLookup)
              this.wjidFC.setValue(null);
          }
        }));
  }

  setFirstJobSite(entity: Permits2PermitEntity) {
    
    if (!entity.JobId && entity?.JobSiteId) {
        this.jobSiteFC.setValue(null);
        this.lastJobId = null;
        return;
    } else if (this.lastJobId == entity.JobId)
      return;

    this.lastJobId = entity.JobId;
    if (!entity.JobId) return;

    this.subscriptions.push(
      // This is cache
      this.dwMetaDataService.getLookup(AppMetaDataLookups.JobSiteSiteInfo, [{ ParamName: 'JobId', ParamValue: entity.JobId.toString() }])
        .subscribe(lookupItems => {
          if (lookupItems.length == 0)
            return;
          if (entity.JobSiteId) {
            const existingLookup = lookupItems.find(li => li.Id == entity.JobSiteId.toString());
            if (existingLookup)
              return;
          }
          const newJobSite = lookupItems[0].Id;
          this.jobSiteFC.setValue(newJobSite);
        }));

  }
}
